import LogoutModal from "./logout-modal.component";

export default LogoutModal;
